"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IS_DOMAIN_WITH_URL_PARAMS = exports.IS_DOMAIN = exports.NOT_STARTING_WITH_FTP = exports.STARTING_WITH_VALID_PROTOCOL = exports.unsafeCharacters = void 0;
exports.unsafeCharacters = ['<', '>', '&', '"', "'"];
exports.STARTING_WITH_VALID_PROTOCOL = /(^http[s]?:\/{2})|(^\/\/)|(^\/)/i;
exports.NOT_STARTING_WITH_FTP = /^(?!ftp:).*/i;
exports.IS_DOMAIN = /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\\-]*[a-zA-Z0-9])\.)+([A-Za-z]|[A-Za-z][A-Za-z0-9\\-]*[A-Za-z0-9])(\/)?$/i;
exports.IS_DOMAIN_WITH_URL_PARAMS = /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\\-]*[a-zA-Z0-9])\.)+([A-Za-z]|[A-Za-z][A-Za-z0-9\\-]*[A-Za-z0-9])(\/?\S*)?$/i;
